import { SecurityDepositConsumeStatus } from '../config/securityDeposit'

export function getUsableAmount(securityDeposit) {
  // paid payments
  const paidAmount =
    (securityDeposit.payment_details &&
      securityDeposit.payment_details.amountPaid) ||
    0

  // adjustments
  const adjustments =
    (securityDeposit.payment_details &&
      securityDeposit.payment_details.adjustments) ||
    []

  const adjustmentsAmount = adjustments.reduce(
    (total, adjustment) => total + adjustment.value,
    0
  )

  // consume payments
  const existingConsumedPayments = securityDeposit.consumePayments || []
  const consumedAmount = existingConsumedPayments.reduce(
    (total, paidPayment) => {
      if (paidPayment.status === SecurityDepositConsumeStatus.FAILED) {
        return total
      }

      return total + paidPayment.amount
    },
    0
  )
  // refunded payments
  const refundedAmount = securityDeposit.refundedAmount || 0

  return paidAmount - adjustmentsAmount - consumedAmount - refundedAmount
}
